const reports = {
  apiClient: null,
  path: '/admin/reports',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getMonthlyReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/monthly?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getBiweeklyReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/biweekly?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async regenerateBiweeklyReport(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/regenerate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getPaymentHealthReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/payment-health?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getOperationalReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/operational?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCustomerHealthReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/customer-health?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCustomerAcquisitionReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/customer-acquisition?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getWalletReport(params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/wallet?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default reports;
